module.exports = __webpack_public_path__ + "static/media/login-left-logo.9c4316f1.svg";